import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel, Country, OrderCreateModel, State } from '../../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-delivery-address-order-card',
    templateUrl: './delivery-address-order-card.component.html',
    styleUrl: './delivery-address-order-card.component.scss',
    standalone: false
})
export class DeliveryAddressOrderCardComponent implements OnInit {
  @Input() order: OrderCreateModel = new OrderCreateModel();
  @Input() countries: Country[] = [];
  @Input() states: State[] = [];
  @Output() nextStep = new EventEmitter<void>();
  @Output() countryId = new EventEmitter<number>();
  @Output() addShippingPrice = new EventEmitter<void>();
  decorativeLineVisible: boolean = false;
  
  ngOnInit() {
    if (!this.order.shippingAddress) {
      this.order.shippingAddress = new AddressModel();
    }
  }

  isAnyFieldFilled(): boolean {
    return !!this.order.shippingAddress.country  || !!this.order.shippingAddress.state?.trim() || !!this.order.shippingAddress.city?.trim() || !!this.order.shippingAddress.postalCode?.trim() || !!this.order.shippingAddress.street?.trim() || !!this.order.shippingAddress.firstname?.trim() || !!this.order.shippingAddress.lastname?.trim() || !!this.order.shippingAddress.phone?.trim() || !!this.order.shippingAddress.email?.trim();
  }
  
  isFormValid(): boolean {
    return !!this.order.shippingAddress.country && !!this.order.shippingAddress.state && !!this.order.shippingAddress.city && !!this.order.shippingAddress.postalCode && !!this.order.shippingAddress.street;
  }

  removeAll() {
    Object.assign(this.order.shippingAddress, {country: '', state: '', city: '', postalCode: '', street: '', firstname: '', lastname: '', phone: '', email: '' });
  }

  openNextStep() {
    this.decorativeLineVisible = true;
    this.nextStep.emit();
    this.addShippingPrice.emit();
  }

    addAddressCountry(event:string) {
      const selectedCountry = this.countries.find(country => country.name == event);

      this.countryId.emit(selectedCountry.id);
      
    }
}
